/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 scene.glb -T 
Files: scene.glb [880.36KB] > C:\Users\Dan\Documents\FRONTEND\Iphone17\WebPageClone\public\models\scene-transformed.glb [79KB] (91%)
*/

import React from "react";
import { useGLTF } from "@react-three/drei";
import { useEffect } from "react";
import * as THREE from "three";

export function Iphone17(props) {
  const { nodes, materials } = useGLTF("/models/scene-transformed.glb");

  const debugColors = [
    "#ff3b30",
    "#ff9500",
    "#ffcc00",
    "#34c759",
    "#5ac8fa",
    "#007aff",
    "#5856d6",
    "#ff2d55",
  ];

  /*  useEffect(() => {
    let index = 0;

    Object.entries(materials).forEach(([name, mat]) => {
      const color = debugColors[index % debugColors.length];
      mat.color = new THREE.Color("#ff00ff");
      mat.map = null;
      mat.needsUpdate = true;
      index += 1;

      console.log("Material:", name, "Color:", color);
    });
  }, [materials]); */

  useEffect(() => {
    const bodyMaterial = materials.PaletteMaterial008;
    const backGlassMaterial = materials.PaletteMaterial007;
    const appleIconLed = materials.PaletteMaterial004;
    const frontGlass = materials.PaletteMaterial005;
    const cameraCircle = materials.PaletteMaterial002;
    const backLed = materials.PaletteMaterial006;
    const centerCamera = materials.PaletteMaterial001;

    /* if (centerCamera) {
      centerCamera.color = new THREE.Color(props.item.color[0]);
      centerCamera.needsUpdate = true;
    } */

    /* if (backLed) {
      backLed.color = new THREE.Color(props.item.color[0]);
      backLed.needsUpdate = true;
    } */

    if (cameraCircle) {
      cameraCircle.map = null; // elimina textura
      cameraCircle.color = new THREE.Color(props.item.color[0]);
      cameraCircle.needsUpdate = true;
    }

    if (bodyMaterial) {
      bodyMaterial.map = null; // elimina textura
      bodyMaterial.color = new THREE.Color(props.item.color[0]);
      bodyMaterial.needsUpdate = true;
    }

    if (appleIconLed) {
      appleIconLed.map = null;
      appleIconLed.color = new THREE.Color(props.item.color[0]);
      appleIconLed.needsUpdate = true;
    }

    if (frontGlass) {
      frontGlass.map = null;
      frontGlass.normalMap = null;
      frontGlass.envMap = null;
      frontGlass.roughnessMap = null;
      frontGlass.metalness = 0;
      frontGlass.roughness = 0.1;
      frontGlass.clearcoat = 1;
      frontGlass.clearcoatRoughness = 0;
      frontGlass.opacity = 1;
      frontGlass.transparent = false;
      frontGlass.color = new THREE.Color(props.item.color[0]);
      frontGlass.needsUpdate = true;
      frontGlass.color = new THREE.Color("#000000");
    }

    if (backGlassMaterial) {
      backGlassMaterial.map = null;
      backGlassMaterial.color = new THREE.Color(props.item.color[0]);
      backGlassMaterial.needsUpdate = true;
    }
  }, [materials, props.item]);

  return (
    <group {...props} dispose={null}>
      <mesh
        geometry={nodes.Lens001.geometry}
        material={materials.PaletteMaterial001}
      />
      <mesh
        geometry={nodes.Back_Flash.geometry}
        material={materials.PaletteMaterial006}
      />
      <mesh
        geometry={nodes.Back_Glass.geometry}
        material={materials.PaletteMaterial007}
      />
      <mesh
        geometry={nodes.Body.geometry}
        material={materials.PaletteMaterial008}
      />
      <mesh
        geometry={nodes.Cylinder004.geometry}
        material={materials.PaletteMaterial002}
      />
      <mesh
        geometry={nodes.Cylinder004_1.geometry}
        material={materials.PaletteMaterial003}
      />
      <mesh
        geometry={nodes.Cylinder004_2.geometry}
        material={materials.PaletteMaterial004}
      />
      <mesh
        geometry={nodes.Cylinder004_3.geometry}
        material={materials.PaletteMaterial005}
      />
    </group>
  );
}

useGLTF.preload("/models/scene-transformed.glb");
